import React, { ChangeEvent, FC, Fragment } from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';

import { TextTransform, ValidatedSwitch } from 'components';
import { GenericStatus, LeaderboardConfigInput } from 'api';

const EnableSwitch: FC = () => {
  const { t } = useTranslation();
  const { setFieldValue } = useFormikContext<LeaderboardConfigInput>();

  function onChange(event: ChangeEvent<HTMLInputElement>, value: boolean) {
    const status = value ? GenericStatus.Active : GenericStatus.Disabled;

    setFieldValue('leaderboard_status', status);
  }

  function checkedFn(value: GenericStatus) {
    return value === GenericStatus.Active;
  }

  return (
    <Fragment>
      <Typography display="inline" variant="subtitle2">
        <TextTransform transform="capitalize">{t('common:enabled')}</TextTransform>
      </Typography>
      <ValidatedSwitch
        color="primary"
        name="leaderboard_status"
        onChange={onChange}
        checkedFn={checkedFn}
      />
    </Fragment>
  );
};

export default EnableSwitch;
